import { Component, EventEmitter, Input, Output } from '@angular/core';

import { IValidation } from './validation/validation.interfaces';
import { ValidationGroup } from './validation/validationgroup';

@Component({
  template: '',
  standalone: false,
})
export abstract class ValueComponent<TValueType> implements IValidation {
  @Input() value: TValueType | null = null;
  @Input() validationGroup: ValidationGroup | null = null;
  @Output() valueChange = new EventEmitter<any>();

  validationErrors: string[] = [];

  onChange(value: string, validate = false): void {
    if (typeof value === 'string') {
      value = value.trim();
      this.value = value as TValueType;
    }

    this.valueChange.emit(value);

    if (validate) {
      this.isValid();
    }
  }

  isValid(): boolean {
    this.validationErrors = [];
    if (this.validationGroup == null) {
      return true;
    }
    const validationResult = this.validationGroup.validate(this.value);
    validationResult.failedRules.forEach((rule) => {
      const keyIsTranslated = rule.key.startsWith('**');
      if (keyIsTranslated) {
        rule.key = rule.key.slice(2);
      }
      const error = keyIsTranslated ? rule.key : `error.${rule.key}`;
      if (this.validationErrors.filter((r) => r == error).length == 0) {
        this.validationErrors.push(error);
      }
    });
    return validationResult.success;
  }
}
